import React from 'react';
import { Campaign } from '../lib/mockData';
interface CampaignTimelineProps {
  campaigns: Campaign[];
}
export function CampaignTimeline({
  campaigns
}: CampaignTimelineProps) {
  return <div className="relative pt-6 pb-2" data-id="element-9">
      {/* Timeline Line */}
      <div className="absolute top-0 bottom-0 left-6 w-0.5 bg-stone-200" data-id="element-10"></div>

      <div className="space-y-8" data-id="element-11">
        {campaigns.map(campaign => <div key={campaign.id} className="relative flex items-start gap-6" data-id="element-12">
            {/* Status Dot */}
            <div className={`
              relative z-10 flex-shrink-0 w-3 h-3 mt-2 rounded-full ring-4 ring-white
              ${campaign.status === 'Active' ? 'bg-teal-500' : campaign.status === 'Completed' ? 'bg-stone-400' : 'bg-coral-400'}
            `} data-id="element-13"></div>

            {/* Content */}
            <div className="flex-1 bg-white border border-stone-200 rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow cursor-pointer" data-id="element-14">
              <div className="flex justify-between items-start mb-2" data-id="element-15">
                <div data-id="element-16">
                  <h4 className="font-semibold text-stone-900" data-id="element-17">
                    {campaign.name}
                  </h4>
                  <div className="text-sm text-stone-500 mt-0.5" data-id="element-18">
                    Testing Window: {campaign.windowStart} -{' '}
                    {campaign.windowEnd}
                  </div>
                </div>
                <span className={`
                  px-2.5 py-0.5 rounded-full text-xs font-medium border
                  ${campaign.status === 'Active' ? 'bg-teal-50 text-teal-700 border-teal-200' : campaign.status === 'Completed' ? 'bg-stone-100 text-stone-600 border-stone-200' : 'bg-amber-50 text-amber-700 border-amber-200'}
                `} data-id="element-19">
                  {campaign.status}
                </span>
              </div>

              {campaign.status === 'Active' && <div className="mt-3" data-id="element-20">
                  <div className="flex justify-between text-xs text-stone-500 mb-1" data-id="element-21">
                    <span data-id="element-22">Completion</span>
                    <span data-id="element-23">{campaign.completionRate}%</span>
                  </div>
                  <div className="w-full h-2 bg-stone-100 rounded-full overflow-hidden" data-id="element-24">
                    <div className="h-full bg-teal-500 rounded-full" style={{
                width: `${campaign.completionRate}%`
              }} data-id="element-25"></div>
                  </div>
                  <div className="mt-2 text-xs text-stone-400" data-id="element-26">
                    Letters scheduled for {campaign.lettersScheduled}
                  </div>
                </div>}
            </div>
          </div>)}
      </div>
    </div>;
}